export enum ProductClass {
    STANDARD = "Standard",
    PRO = "pro",
    PROPLUS = "proplus",
}